function onMobileFilter() {
  function closeOverlay(e) {
    e?.stopPropagation();
    const wrapper = $('.filter__object');
    wrapper.hide();
    $('body').css('overflow', 'visible');
    calculateFilters();
  }

  function showOverlay(e) {
    e?.stopPropagation();
    const wrapper = $('.filter__object');
    wrapper.show();
    $('body').css('overflow', 'hidden');
  }

  function calculateFilters() {
    const filterCount = $('.filter__count');
    const calcLength = $('#selected-categories .selected-category').length;

    if (calcLength > 0) {
      filterCount.text(calcLength);
      filterCount.show();
    } else {
      filterCount.hide();
    }

  }

  $('.close-overlay').click(function (e) {
    closeOverlay(e);
  });

  $('#openFilterOverlay').click(function (e) {
    showOverlay(e);
  });

  if ($(window).width() < 576) {
    closeOverlay();
    calculateFilters();
  }
}

export default onMobileFilter;